"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_CONSTANTS = exports.default = void 0;

var _ValidatorManager = _interopRequireDefault(require("./ValidatorManager"));

var DATA_CONSTANTS = _interopRequireWildcard(require("./mappings/FIELD_CONSTANTS"));

exports.DATA_CONSTANTS = DATA_CONSTANTS;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Martel-validator entry point
 */
var _default = _ValidatorManager.default;
exports.default = _default;
//# sourceMappingURL=index.js.map